import { styled } from 'styled-components';

//:horizon://import reactDatepickerCss from 'react-datepicker/dist/react-datepicker.css?raw';

const reactDatepickerCss = '';

export const ReactDatepickerWrapperHoler = styled.div`
  ${reactDatepickerCss};
`;
